module.exports = __webpack_public_path__ + "media/images/amenities_icons/toastmaster-ce177bbbc995352dcddf5438d4f49315.svg";